/**
 * ContactCard — Adresse, Telefon, E-Mail, Website.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Globe } from 'lucide-react';

export const ContactCard = ({ formData, onChange }) => (
  <Card className="border-border/60">
    <CardHeader>
      <CardTitle className="font-heading flex items-center gap-2">
        <Globe className="h-5 w-5 text-primary" />
        Kontaktdaten
      </CardTitle>
      <CardDescription>Adresse und Erreichbarkeit</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="address">Straße & Hausnummer</Label>
        <Input id="address" value={formData.address} onChange={(e) => onChange('address', e.target.value)} placeholder="Musterstraße 123" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="postal_code">PLZ</Label>
          <Input id="postal_code" value={formData.postal_code} onChange={(e) => onChange('postal_code', e.target.value)} placeholder="12345" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="city">Stadt</Label>
          <Input id="city" value={formData.city} onChange={(e) => onChange('city', e.target.value)} placeholder="Musterstadt" />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="phone">Telefon</Label>
          <Input id="phone" value={formData.phone} onChange={(e) => onChange('phone', e.target.value)} placeholder="+49 123 456789" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">E-Mail</Label>
          <Input id="email" type="email" value={formData.email} onChange={(e) => onChange('email', e.target.value)} placeholder="info@firma.de" />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="website">Website</Label>
        <Input id="website" value={formData.website} onChange={(e) => onChange('website', e.target.value)} placeholder="https://www.firma.de" />
      </div>
    </CardContent>
  </Card>
);
